import moment from "moment";
import * as schemaProject from "~/schemas/schema.projects.jsx";
import * as schemaStopwatch from "~/schemas/schema.stopwatches.jsx";
import * as schemaTask from "~/schemas/schema.tasks.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const stopwatchStart = (parent_type, parent_id, elapsed = 0) => {
  return {
    types: [
      actionTypes.STOPWATCH_START_LOADING,
      actionTypes.STOPWATCH_START_SUCCESS,
      actionTypes.STOPWATCH_START_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /* eslint-enable */ url: `${Angie.api_url}/stopwatches`,
        method: `post`,
        body: {
          parent_type,
          parent_id,
          elapsed,
        },
      }),
    payload: {
      parent_type,
      parent_id,
      elapsed,
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    },
  };
};

export const stopwatchPause = (id, startedOn, previousElapsed, nextElapsed) => {
  return {
    types: [
      actionTypes.STOPWATCH_PAUSE_LOADING,
      actionTypes.STOPWATCH_PAUSE_SUCCESS,
      actionTypes.STOPWATCH_PAUSE_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /* eslint-enable */ url: `${Angie.api_url}/stopwatches/${id}/pause`,
        method: `PUT`,
      }),
    payload: {
      id,
      startedOn,
      previousElapsed,
      nextElapsed,
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    },
  };
};

export const fetchStopwatches = () => {
  return {
    types: [
      actionTypes.STOPWATCHES_FETCH_LOADING,
      actionTypes.STOPWATCHES_FETCH_SUCCESS,
      actionTypes.STOPWATCHES_FETCH_ERROR,
    ],
    /* eslint-disable */
    callAPI: () =>
      fetch({
        /* eslint-enable */ url: `${Angie.api_url}/stopwatches`,
      }),
    payload: {
      schema: {
        projects: schemaProject.arrayOfProjects,
        stopwatches: schemaStopwatch.arrayOfStopwatches,
        tasks: schemaTask.arrayOfTasks,
      },
    },
  };
};

export const fetchStopwatchesOffset = () => {
  return {
    types: [
      actionTypes.STOPWATCHES_FETCH_OFFSET_LOADING,
      actionTypes.STOPWATCHES_FETCH_OFFSET_SUCCESS,
      actionTypes.STOPWATCHES_FETCH_OFFSET_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/stopwatches/offset`,
        method: `POST`,
        body: {
          timestamp: moment().utc().unix(),
        },
      }),
  };
};

export const stopwatchResume = (id, startedOn) => {
  return {
    types: [
      actionTypes.STOPWATCH_RESUME_LOADING,
      actionTypes.STOPWATCH_RESUME_SUCCESS,
      actionTypes.STOPWATCH_RESUME_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /* eslint-enable */ url: `${Angie.api_url}/stopwatches/${id}/resume`,
        method: `PUT`,
      }),
    payload: {
      id,
      startedOn,
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    },
  };
};

export const stopwatchDelete = (id) => {
  return {
    types: [
      actionTypes.STOPWATCH_DELETE_LOADING,
      actionTypes.STOPWATCH_DELETE_SUCCESS,
      actionTypes.STOPWATCH_DELETE_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /* eslint-enable */ url: `${Angie.api_url}/stopwatches/${id}`,
        method: `DELETE`,
      }),
    payload: {
      id,
    },
  };
};

export const stopwatchEdit = (id, attributes) => {
  return {
    types: [actionTypes.STOPWATCH_EDIT_LOADING, actionTypes.STOPWATCH_EDIT_SUCCESS, actionTypes.STOPWATCH_EDIT_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/stopwatches/${id}`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      id,
      attributes,
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    },
  };
};

export const stopwatchMerge = (unassignedStopwatchId, parentType, parentId) => {
  return {
    types: [
      actionTypes.STOPWATCH_MERGE_LOADING,
      actionTypes.STOPWATCH_MERGE_SUCCESS,
      actionTypes.STOPWATCH_MERGE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/stopwatches/${unassignedStopwatchId}/merge`,
        method: `PUT`,
        body: {
          id: unassignedStopwatchId,
          parent_type: parentType,
          parent_id: parentId,
        },
      }),
    payload: {
      unassignedStopwatchId,
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    },
  };
};

const stopwatchFromEventStream = (data = {}, type) => {
  if (data && data.id) {
    return {
      type,
      parent_type: data.parent_type,
      parent_id: data.parent_id,
      id: data.id,
      elapsed: data.elapsed,
      response: {
        single: data,
      },
      schema: {
        single: schemaStopwatch.stopwatch,
      },
    };
  }
};

export const stopwatchStartedFromEventStream = (data) => {
  return stopwatchFromEventStream(data, actionTypes.STOPWATCH_STARTED_FROM_EVENT_STREAM);
};

export const stopwatchUpdatedFromEventStream = (data) => {
  return stopwatchFromEventStream(data, actionTypes.STOPWATCH_UPDATED_FROM_EVENT_STREAM);
};

export const stopwatchDeletedFromEventStream = (data) => {
  return stopwatchFromEventStream(data, actionTypes.STOPWATCH_DELETED_FROM_EVENT_STREAM);
};
